/**
 * Carte recette dans la grille Assistant Vide-Frigo
 */

import React from "react";
import { getDifficultyColor, getMatchColor } from "../utils/recipeHelpers.js";

export default function FridgeRecipeCard({ recipe, onSelect, t }) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onSelect(recipe)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onSelect(recipe);
        }
      }}
      className="bg-white dark:bg-slate-800 rounded-xl shadow-lg hover:shadow-xl transition-all overflow-hidden cursor-pointer border border-slate-200 dark:border-slate-600 hover:border-orange-500/50 focus:outline-none focus:ring-2 focus:ring-orange-500/50"
    >
      <div className="h-36 bg-slate-100 dark:bg-slate-700 relative overflow-hidden">
        {recipe.image && (
          <img
            src={recipe.image}
            alt=""
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextElementSibling?.classList.remove("hidden");
            }}
          />
        )}
        <div
          className={`absolute inset-0 flex items-center justify-center ${recipe.image ? "hidden" : ""}`}
        >
          <span className="text-4xl">🍽️</span>
        </div>
        <div className="absolute top-2 right-2">
          <span
            className={`${getMatchColor(recipe.matchPercentage)} text-white px-2.5 py-1 rounded-lg text-xs font-bold shadow`}
          >
            {recipe.matchPercentage}%
          </span>
        </div>
        {recipe.source === "TheMealDB" && (
          <div className="absolute top-2 left-2">
            <span className="bg-emerald-500/90 text-white px-2 py-0.5 rounded text-xs font-medium">
              Internet
            </span>
          </div>
        )}
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h3 className="text-base font-bold text-slate-900 dark:text-white line-clamp-2 flex-1">
            {recipe.title}
          </h3>
          <span
            className={`shrink-0 px-2 py-0.5 rounded text-xs font-medium border ${getDifficultyColor(recipe.difficulty)}`}
          >
            {recipe.difficulty}
          </span>
        </div>
        <div className="mb-3">
          <div className="flex items-center justify-between text-xs text-slate-600 dark:text-slate-400 mb-1">
            <span>
              {t("youHaveIngredients")} : {recipe.matchCount}/
              {recipe.totalIngredients}
            </span>
          </div>
          <div className="w-full bg-slate-200 dark:bg-slate-600 rounded-full h-1.5 overflow-hidden">
            <div
              className={`h-full ${getMatchColor(recipe.matchPercentage)} transition-all duration-500`}
              style={{ width: `${recipe.matchPercentage}%` }}
            />
          </div>
        </div>
        {recipe.missingIngredients?.length > 0 && (
          <p className="text-xs text-slate-500 dark:text-slate-400 mb-3 line-clamp-2">
            {t("youAreMissing")} :{" "}
            {recipe.missingIngredients.slice(0, 2).join(", ")}
          </p>
        )}
        <span className="inline-flex items-center justify-center gap-1.5 w-full py-2 rounded-lg bg-gradient-to-r from-orange-500 to-amber-500 text-white text-sm font-semibold">
          {t("viewDetails")}
          {recipe.youtube && <span title={t("watchVideo")}>🎥</span>}
        </span>
      </div>
    </div>
  );
}
